// extracted by mini-css-extract-plugin
export default {"root":"ExpertsMenuPage_root__94Rae","header":"ExpertsMenuPage_header__2PMEU","body":"ExpertsMenuPage_body__9-mS8"};